<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { Enveloppe } from "@/types/file.types";

export default defineComponent({
  props: {
    chatOpen:{
      type: Boolean,
      required: false,
      default: false,
    },
    chatId:{
      type: String,
      required: true,
    },
    sender:{
      type: String,
      required: false,
      default: "User",
    },
    message:{
      type: String,
      required: false,
      default: "@mention",
    },
  },
});
</script>

<template>
  <div
    class="notif-new-set"
    :style="{ right: chatOpen ? 'calc(500px + 1rem)' : '1rem' }"
    @click="$emit('goToChat',chatId)"
  >
<Avatar class="new-avatar" :name="sender"></Avatar>
    <div class="new-set-info">
      <div class="new-set-title">
        {{ sender }}
      </div>
      <div class="new-set-text" v-html="message">
      </div>
      <ButtonItem
        :msg="$t('global.new-set-button')"
        :design="{ fontSize: '1rem' }"
        class="new-set-button"
      />
    </div>
    <CloseIcon
      class="new-set-close"
      @click="
        () => {
          $emit('close');
        }
      "
    />
  </div>
</template>

<style scoped>
.notif-new-set .new-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background-color: var(--bg2);
}
.notif-new-set {
  position: fixed;
  display: flex;
  gap: 1rem;
  padding: 1rem;
  bottom: 1rem;
  right: 1rem;
  background-color: var(--bg3);
  border-radius: 20px;
  box-shadow: 0 4px 4px #00000069;
  border: 1px solid var(--text-low-emphasis);
  z-index: 21;
}
.new-set-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
}
.new-set-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap:.5rem;
  margin-right: 1.5rem;
}
.new-set-button {
  margin-left: auto;
  padding: 0.5rem 2rem;
}
.new-set-title {
  font-weight: 700;
}
.new-set-text {
  font-size: 0.9rem;
  color: var(--text-medium-emphasis);
  padding-right: 10rem;
  user-select: none;
  pointer-events:none;
}
</style>
